import { render, staticRenderFns } from "./LoginAlias.vue?vue&type=template&id=8c9e99e4&scoped=true"
import script from "./LoginAlias.vue?vue&type=script&lang=js"
export * from "./LoginAlias.vue?vue&type=script&lang=js"
import style0 from "./LoginAlias.vue?vue&type=style&index=0&id=8c9e99e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9e99e4",
  null
  
)

export default component.exports